import {memo, shapeComponent, ShapeComponent, View} from "shared/base"
import React, {useMemo} from "react"
import {ComponentsUtilsPhoneNumber} from "components/utils/phone-number"
import InputContainer from "./input-container"

export default memo(shapeComponent(class ComponentsChalkyLayoutPhoneNumber extends ShapeComponent {
  setup() {
    this.useStates({
      countrySelectFocus: false,
      phoneNumberTextInputFocus: false,
      valuePresent: false
    })
  }

  render() {
    const {label, onChangeNumber, ...restProps} = this.props
    const {countrySelectFocus, phoneNumberTextInputFocus, valuePresent} = this.s

    const defaultStyle = useMemo(() => {
      const defaultStyle = {
        backgroundColor: "#f0f4fc",
        border: "1px solid #f0f4fc",
        borderRadius: 8,
        outlineStyle: "none"
      }

      if (countrySelectFocus || phoneNumberTextInputFocus) {
        defaultStyle.backgroundColor = "#fff"
        defaultStyle.border = "1px solid #fff"
        defaultStyle.boxShadow = "0px 14px 40px 0px rgba(44, 44, 150, 0.2)"
      } else if (valuePresent) {
        defaultStyle.border = "1px solid #d6e2f9"
      }

      return defaultStyle
    }, [countrySelectFocus, phoneNumberTextInputFocus])

    const phoneNumberStyle = useMemo(() => {
      const phoneNumberStyle = {
        color: "#2c2c96",
        fontSize: 16,
        outlineStyle: "none",
        paddingTop: 14,
        paddingRight: 24,
        paddingBottom: 14,
        paddingLeft: 0
      }

      if (valuePresent) {
        phoneNumberStyle.fontWeight = 600
      }

      return phoneNumberStyle
    }, [valuePresent])

    return (
      <InputContainer label={label}>
        <View style={defaultStyle}>
          <ComponentsUtilsPhoneNumber
            countrySelectProps={this.countrySelectProps ||= {
              onBlur: this.tt.onCountrySelectBlur,
              onFocus: this.tt.onCountrySelectFocus,
              styles: {
                selectContainer: {
                  paddingLeft: 20
                }
              },
              transparent: true,
              woofInputStyling: false
            }}
            onBlur={this.tt.onPhoneNumberTextInputBlur}
            onChangeNumber={this.tt.onChangeNumber}
            onFocus={this.tt.onPhoneNumberTextInputFocus}
            placeholderTextColor="#6783b8"
            style={phoneNumberStyle}
            transparent
            {...restProps}
          />
        </View>
      </InputContainer>
    )
  }

  onChangeNumber = (newNumber) => {
    this.setState({valuePresent: Boolean(newNumber)})
    this.p.onChangeNumber(newNumber)
  }

  onCountrySelectBlur = () => this.setState({countrySelectFocus: false})
  onCountrySelectFocus = () => this.setState({countrySelectFocus: true})

  onPhoneNumberTextInputBlur = () => this.setState({phoneNumberTextInputFocus: false})
  onPhoneNumberTextInputFocus = () => this.setState({phoneNumberTextInputFocus: true})
}))
